import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getSettings } from '../lib/firestore';

const SettingsContext = createContext();
export const useSettings = () => useContext(SettingsContext);

// Site-wide admin-editable media (hero banner image, packaging option photos). Defaults to
// an empty object on load/error so every consumer just falls back to its built-in default
// (yellow hero background, icon-only packaging buttons) until an admin sets something.
export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const s = await getSettings();
      setSettings(s || {});
    } catch (e) {
      console.error('Settings fetch error:', e);
      setSettings({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, loading, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};
